var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkin"},[_c('div',{staticClass:"align-middle"},[_c('span',{staticClass:"muted"},[_vm._v("Già prenotato?")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",attrs:{"md-align":"center"},on:{"click":_vm.goTo}},[_vm._v("Effettua il Check-in")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46856cf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/common/components/checkin/Checkin.vue
// module id = null
// module chunks = 